import { createFileRoute } from '@tanstack/react-router';

import { PortalHomePage } from '../../portal/home-page';

/** `/account` — the portal home (M10.4, FR-PORTAL-02). Guarded by the layout above. */
export const Route = createFileRoute('/account/')({
  component: PortalHomePage,
});
